/**
 * Root layout route
 *
 * This is the root layout that wraps all routes.
 * Contains the base HTML structure and outlet for child routes.
 */
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { AppShell } from "@/components/layout";

// Lazy load devtools for development only
const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/react-router-devtools").then((module) => ({
        default: module.TanStackRouterDevtools,
      }))
    )
  : () => null;

/**
 * Root route component with app shell
 */
function RootComponent() {
  return (
    <AppShell>
      <Outlet />
      {import.meta.env.DEV && (
        <Suspense>
          <TanStackRouterDevtools />
        </Suspense>
      )}
    </AppShell>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
